import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import NhanXetMau from "../components/NhanXetMau.jsx";
import { CO_CAU_HINH } from "../lib/firebase.js";
import {
  dangNhapGoogle, emailDangCho, emailHopLe, guiLienKet, hoanTatDangNhap,
  ketQuaChuyenHuong, laLienKetDangNhap, theoDoiDangNhap,
} from "../lib/auth.js";
import { docYeuCau, docYeuCauCuaToi, guiYeuCau, xoaYeuCau } from "../lib/nhanXetDeck.js";
import { GIAI_DOAN, VONG, TRANG_THAI, TRAN_MB, GIOI_HAN_TUAN, SO_NGAY_HAN_MUC, THOI_GIAN_CHO, NGAY_GIU_DECK, hanMuc, cacLuot, luotTruocCoKetQua, khoaCongTy } from "@shared/nhanXetDeck.js";
import KetQuaNhanXet from "../components/KetQuaNhanXet.jsx";
import { track } from "../lib/track.js";

/**
 * /nhan-xet-deck: founder gửi pitch deck, AI tự nhận xét từng slide và gửi kết quả
 * trong 15 đến 30 phút. Mỗi tài khoản tối đa GIOI_HAN_TUAN lần trong 7 ngày.
 *
 * Phần giới thiệu luôn hiện (cả khi chưa đăng nhập, cả lúc prerender) vì đây
 * là trang Google sẽ index. Đăng nhập chỉ cần ở bước gửi: phải biết gửi kết
 * quả về đâu, và chỉ chủ deck mới được xem nhận xét.
 */

const TRONG = { congTy: "", nganh: "", giaiDoan: GIAI_DOAN[0], vong: VONG[1], soVon: "", canGopY: "", dongY: false };
const ngayVN = (d) => (d ? d.toLocaleDateString("vi-VN") : "");
const gioVN = (ms) => (ms ? new Date(ms).toLocaleString("vi-VN", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" }) : "");
/** Ba bước, hiển thị dạng thẻ giống thẻ công cụ ở /cong-cu. */
const BUOC = [
  { ten: "Gửi deck PDF", moTa: "Đăng nhập bằng email, tải file lên.", thoiGian: "Khoảng 2 phút", mau: "#f4a623" },
  { ten: "AI đọc và nhận xét", moTa: "AI đọc từng slide, kiểm tra số liệu và chấm theo checklist của site.", thoiGian: "Tự động", mau: "#9fb7e0" },
  { ten: "Nhận báo cáo", moTa: "Xem ngay trên trang này, kèm email báo khi có kết quả.", thoiGian: THOI_GIAN_CHO, mau: "#86cfaa" },
];
const dangMo = (y) => y.status === "moi" || y.status === "dang_xem";
/** Gom các yêu cầu thành từng deck (cùng tên công ty), deck mới gửi gần nhất lên đầu. */
function nhomTheoDeck(ds) {
  const daGap = new Set();
  const ra = [];
  for (const y of ds) {
    const k = khoaCongTy(y.congTy) || y.id;
    if (daGap.has(k)) continue;
    daGap.add(k);
    ra.push(cacLuot(ds, y.id));
  }
  return ra;
}

function DangNhap() {
  const [email, setEmail] = useState("");
  const [tt, setTt] = useState("");
  const [ban, setBan] = useState(false);
  async function google() {
    setTt(""); try { await dangNhapGoogle(); } catch (e) { setTt(e.message); }
  }
  async function guiLink(e) {
    e.preventDefault();
    if (!emailHopLe(email)) { setTt("Email chưa đúng định dạng."); return; }
    setBan(true);
    try { const dc = await guiLienKet(email, "/nhan-xet-deck"); setTt(`Đã gửi liên kết đăng nhập tới ${dc}. Mở hộp thư và bấm vào liên kết để quay lại đây.`); }
    catch (err) { setTt(err.message); } finally { setBan(false); }
  }
  return (
    <div className="surface nx-dang-nhap">
      <h2>Đăng nhập để gửi deck</h2>
      <p className="nho">Cần tài khoản để gửi nhận xét về đúng người, và để chỉ bạn xem được nhận xét. Không có mật khẩu nào phải nhớ.</p>
      <button type="button" className="nut" onClick={google}>Tiếp tục với Google</button>
      <form onSubmit={guiLink} className="nx-email">
        <label htmlFor="nx-email">Hoặc nhận liên kết đăng nhập qua email</label>
        <div className="hang-nut">
          <input id="nx-email" type="email" value={email} autoComplete="email" placeholder="ban@congty.vn" onChange={(e) => setEmail(e.target.value)} />
          <button type="submit" className="nut phu" disabled={ban}>{ban ? "Đang gửi…" : "Gửi liên kết"}</button>
        </div>
      </form>
      {tt && <p className="nho" role="status">{tt}</p>}
    </div>
  );
}

function FormGui({ user, onDaGui, luotCu = null, conLai = GIOI_HAN_TUAN }) {
  // Gửi bản đã sửa: điền sẵn bối cảnh của lượt trước, giữ đúng tên công ty để
  // hai lượt được xếp chung một deck.
  const [form, setForm] = useState(() => (luotCu
    ? { ...TRONG, congTy: luotCu.congTy || "", nganh: luotCu.nganh || "", giaiDoan: luotCu.giaiDoan || TRONG.giaiDoan, vong: luotCu.vong || TRONG.vong, soVon: luotCu.soVon || "" }
    : TRONG));
  const [tep, setTep] = useState(null);
  const [tienDo, setTienDo] = useState(null);
  const [loi, setLoi] = useState("");
  const set = (k, v) => setForm((o) => ({ ...o, [k]: v }));
  async function gui(e) {
    e.preventDefault();
    setLoi(""); setTienDo(0);
    try {
      const id = await guiYeuCau(user, form, tep, setTienDo);
      track("deck_review_submit", {});
      onDaGui(id);
    } catch (err) { setLoi(err.message); setTienDo(null); }
  }
  const dangGui = tienDo != null;
  return (
    <form className="surface story-form nx-form" onSubmit={gui}>
      <h2>{luotCu ? `Gửi bản đã sửa của ${luotCu.congTy}` : "Gửi deck"}</h2>
      {luotCu && <p className="nho">Giữ nguyên tên công ty để nhận xét lần này được xếp là lượt tiếp theo và so với lượt trước. Deck cũ và nhận xét cũ vẫn được giữ để bạn xem lại.</p>}
      <fieldset>
        <legend>Tệp pitch deck</legend>
        <label htmlFor="nx-tep">Tệp PDF, tối đa {TRAN_MB} MB</label>
        <input id="nx-tep" type="file" accept="application/pdf,.pdf" onChange={(e) => setTep(e.target.files?.[0] || null)} required />
        <p className="nho">Làm deck bằng PowerPoint, Keynote, Google Slides hay Canva: chọn Xuất (Export) hoặc Tải xuống dạng PDF.</p>
      </fieldset>
      <fieldset>
        <legend>Bối cảnh</legend>
        <div className="o-nhap">
          <div><label htmlFor="nx-cong-ty">Công ty hoặc dự án</label><input id="nx-cong-ty" type="text" value={form.congTy} onChange={(e) => set("congTy", e.target.value)} required /></div>
          <div><label htmlFor="nx-nganh">Ngành</label><input id="nx-nganh" type="text" value={form.nganh} placeholder="SaaS, F&B, logistics…" onChange={(e) => set("nganh", e.target.value)} /></div>
          <div><label htmlFor="nx-giai-doan">Giai đoạn</label><select id="nx-giai-doan" value={form.giaiDoan} onChange={(e) => set("giaiDoan", e.target.value)}>{GIAI_DOAN.map((x) => <option key={x}>{x}</option>)}</select></div>
          <div><label htmlFor="nx-vong">Vòng định gọi</label><select id="nx-vong" value={form.vong} onChange={(e) => set("vong", e.target.value)}>{VONG.map((x) => <option key={x}>{x}</option>)}</select></div>
          <div><label htmlFor="nx-so-von">Số vốn định gọi</label><input id="nx-so-von" type="text" value={form.soVon} placeholder="Ví dụ: 5 tỷ" onChange={(e) => set("soVon", e.target.value)} /></div>
        </div>
        <label htmlFor="nx-can-gop-y">Bạn muốn được góp ý kỹ nhất ở phần nào? <span className="nho">(không bắt buộc)</span></label>
        <textarea id="nx-can-gop-y" rows="4" value={form.canGopY} placeholder="Ví dụ: quỹ hay hỏi vì sao định giá 30 tỷ, slide tài chính đang rối…" onChange={(e) => set("canGopY", e.target.value)} />
      </fieldset>
      <div className="story-checks">
        <label className="story-consent"><input type="checkbox" checked={form.dongY} onChange={(e) => set("dongY", e.target.checked)} required /><span>Tôi đồng ý để fundraising.vn lưu deck và dùng AI đọc, nhận xét deck, theo <Link to="/quyen-rieng-tu#nhan-xet-pitch-deck">chính sách quyền riêng tư</Link>.</span></label>
      </div>
      {loi && <p className="story-loi" role="alert">{loi}</p>}
      <div className="hang-nut">
        <button className="nut" type="submit" disabled={dangGui}>{dangGui ? `Đang tải lên ${tienDo}%…` : "Gửi deck để nhận xét"}</button>
        <span className="nho">Đang đăng nhập: {user.email}. Còn {conLai}/{GIOI_HAN_TUAN} lần trong {SO_NGAY_HAN_MUC} ngày.</span>
      </div>
    </form>
  );
}

function ChiTiet({ id, onXoa, onCapNhat, ds = [] }) {
  const [yc, setYc] = useState(undefined);
  const [loi, setLoi] = useState("");
  const [xacNhan, setXacNhan] = useState(false);
  useEffect(() => { docYeuCau(id).then(setYc).catch((e) => { setLoi(e.code === "permission-denied" ? "Bạn không có quyền xem yêu cầu này. Hãy đăng nhập đúng email đã gửi deck." : e.message); setYc(null); }); }, [id]);
  // Đang chờ AI: hỏi lại mỗi 20 giây để kết quả hiện ra mà không phải tải lại trang.
  const choKetQua = yc && dangMo(yc);
  useEffect(() => {
    if (!choKetQua) return undefined;
    const t = setInterval(() => { docYeuCau(id).then((m) => { if (m && !dangMo(m)) { setYc(m); onCapNhat?.(); } }).catch(() => {}); }, 20000);
    return () => clearInterval(t);
  }, [choKetQua, id]);
  if (yc === undefined) return <p>Đang tải…</p>;
  if (!yc) return <section className="surface"><p>{loi || "Không tìm thấy yêu cầu này. Có thể bạn đã xoá nó."}</p><Link to="/nhan-xet-deck">Về trang gửi deck</Link></section>;
  const tt = TRANG_THAI[yc.status] || TRANG_THAI.moi;
  async function xoa() {
    try { await xoaYeuCau(yc); onXoa(); } catch (e) { setLoi(e.message); }
  }
  return (
    <div className="nx-chi-tiet">
      <p className="eyebrow"><Link to="/nhan-xet-deck">Nhận xét pitch deck</Link> / {yc.congTy}</p>
      {/* Khi đã có kết quả, bảng tổng quan của báo cáo đã có tên công ty, tệp và ngày. */}
      {yc.status !== "da_gui" && <>
        <h1>Nhận xét deck {yc.congTy}</h1>
        <p className="nho">Gửi ngày {ngayVN(yc.createdAt)}, tệp {yc.deckTen}. <span className="pill">{tt.nhan}</span></p>
      </>}
      {yc.status === "da_gui" && <h1 className="sr-only">Nhận xét deck {yc.congTy}</h1>}
      {dangMo(yc) && <section className="surface"><p>{tt.moTa} Nhận xét thường có trong {THOI_GIAN_CHO}; trang này tự cập nhật, và chúng tôi cũng báo qua {yc.email}. Bạn đóng trang lúc này cũng được.</p></section>}
      {yc.status === "tu_choi" && <section className="surface"><p>{yc.lyDoTuChoi || "Lần này chúng tôi chưa nhận xét được deck."}</p></section>}
      {yc.status === "da_gui" && <KetQuaNhanXet nx={yc.ketQua} yc={yc} cacLuot={cacLuot(ds, id)} truoc={luotTruocCoKetQua(ds, id)} />}
      {yc.status !== "da_gui" && cacLuot(ds, id).length > 1 && (
        <section className="surface">
          <p className="nho">Đây là lượt {cacLuot(ds, id).find((y) => y.id === id)?.luot} của deck này. Các lượt trước:</p>
          <ul>{cacLuot(ds, id).filter((y) => y.id !== id).map((y) => <li key={y.id}><Link to={`/nhan-xet-deck?xem=${y.id}`}>Lượt {y.luot}, {ngayVN(y.createdAt)}</Link>{y.ketQua?.diemTong != null && <span className="nho"> ({y.ketQua.diemTong} điểm)</span>}</li>)}</ul>
        </section>
      )}
      {loi && <p className="story-loi" role="alert">{loi}</p>}
      <div className="nx-xoa">
        {!xacNhan
          ? <button type="button" className="text-button danger" onClick={() => setXacNhan(true)}>Xoá deck và nhận xét này…</button>
          : <p>Xoá vĩnh viễn tệp deck và nhận xét? <button type="button" className="nut nut-nguy-hiem" onClick={xoa}>Xoá vĩnh viễn</button> <button type="button" className="text-button" onClick={() => setXacNhan(false)}>Huỷ</button></p>}
        {yc.deckDaXoa && <p className="nho">Tệp deck đã được tự xoá sau {NGAY_GIU_DECK} ngày; nhận xét vẫn còn.</p>}
      </div>
    </div>
  );
}

export default function NhanXetDeck() {
  const [params, setParams] = useSearchParams();
  const xem = params.get("xem");
  const [user, setUser] = useState(undefined);
  const [ds, setDs] = useState([]);
  const [tt, setTt] = useState("");

  useEffect(() => theoDoiDangNhap(setUser), []);
  // Hoàn tất đăng nhập khi quay lại từ liên kết email hoặc chuyển hướng Google.
  useEffect(() => {
    if (!CO_CAU_HINH) return;
    ketQuaChuyenHuong();
    laLienKetDangNhap().then((la) => { if (la) hoanTatDangNhap(emailDangCho()).catch((e) => setTt(e.message)); });
  }, []);
  const [lanTai, setLanTai] = useState(0);
  useEffect(() => { if (user) docYeuCauCuaToi(user.uid).then(setDs).catch(() => setDs([])); else setDs([]); }, [user, xem, lanTai]);

  useEffect(() => {
    if (params.get("luotTiep") && ds.length) document.getElementById("gui-deck")?.scrollIntoView({ behavior: "smooth" });
  }, [params, ds]);
  if (xem && user) return <ChiTiet id={xem} ds={ds} onXoa={() => setParams({})} onCapNhat={() => setLanTai((n) => n + 1)} />;
  const luotCu = ds.find((y) => y.id === params.get("luotTiep")) || null;

  const coDangMo = ds.some(dangMo);
  const hm = hanMuc(ds);
  return (
    <div className="story-form-page nx-trang">
      {/* Đầu trang: lời giới thiệu + ví dụ báo cáo tự chuyển màn, rồi dải quy trình
          3 bước. Founder thấy trước mình nhận được gì trước khi gửi deck. */}
      <header className="nxm-dau">
        <div>
          <p className="eyebrow">Dịch vụ miễn phí</p>
          <h1>Nhận xét pitch deck</h1>
          <p className="lead">Gửi deck dạng PDF, nhận lại nhận xét từng slide sau {THOI_GIAN_CHO}: nhà đầu tư sẽ thấy gì, việc nào nên sửa trước, và câu chữ gợi ý để viết lại.</p>
          <div className="cc-dau-nut">
            <a className="nut" href="#gui-deck">Gửi deck của bạn ↓</a>
            <Link className="cc-dau-link" to="/cong-cu/pitch-deck-10-slide">Tự chấm trước với checklist 10 slide →</Link>
          </div>
        </div>
        <NhanXetMau />
      </header>
      <ol className="cc-luoi nx-buoc" aria-label="Quy trình nhận xét">
        {BUOC.map((x, i) => (
          <li key={x.ten} className="cct" style={{ "--mau": x.mau }}>
            <span className="cct-dau">
              <span className="cct-icon nx-so">{i + 1}</span>
              <span className="cct-tram">Bước {i + 1}</span>
            </span>
            <span className="cct-ten">{x.ten}</span>
            <span className="cct-hoi">{x.moTa}</span>
            <span className="cct-chan"><span>{x.thoiGian}</span></span>
          </li>
        ))}
      </ol>

      <div className="story-layout" id="gui-deck">
        <div>
          {tt && <p className="story-loi" role="alert">{tt}</p>}
          {xem && user === null && <section className="surface"><p>Đăng nhập bằng đúng email đã gửi deck để xem nhận xét.</p></section>}
          {!CO_CAU_HINH ? <section className="surface"><p>Tính năng đang bảo trì. Bạn gửi deck tạm qua xin-chao@fundraising.vn nhé.</p></section>
            : user === undefined ? <p className="nho">Đang kiểm tra đăng nhập…</p>
            : !user ? <DangNhap />
            : (
              <>
                {ds.length > 0 && (
                  <section className="surface nx-cua-toi">
                    <h2>Deck bạn đã gửi</h2>
                    <p className="nho">Mỗi lần gửi bản đã sửa là một lượt. Deck và nhận xét của từng lượt đều được giữ để so sánh.</p>
                    <ul>{nhomTheoDeck(ds).map((nhom) => (
                      <li key={nhom[0].id}>
                        <strong>{nhom[0].congTy}</strong>
                        <ol className="nx-luot-ds">{[...nhom].reverse().map((y) => (
                          <li key={y.id}><Link to={`/nhan-xet-deck?xem=${y.id}`}>Lượt {y.luot}</Link> <span className="nho">{ngayVN(y.createdAt)}{y.ketQua?.diemTong != null ? `, ${y.ketQua.diemTong} điểm` : ""}</span> <span className="pill">{(TRANG_THAI[y.status] || TRANG_THAI.moi).nhan}</span></li>
                        ))}</ol>
                      </li>
                    ))}</ul>
                  </section>
                )}
                {coDangMo
                  ? <section className="surface"><p>Deck trước của bạn đang được nhận xét, thường xong trong {THOI_GIAN_CHO}. Bạn gửi deck mới sau khi nhận kết quả nhé, để nhận xét lần sau dựa trên bản đã sửa.</p></section>
                  : hm.conLai <= 0
                    ? <section className="surface"><p>Bạn đã dùng hết {GIOI_HAN_TUAN} lần nhận xét trong {SO_NGAY_HAN_MUC} ngày. Lượt tiếp theo mở lại lúc {gioVN(hm.moLaiLuc)}. Trong lúc chờ, bạn sửa deck theo nhận xét đã có và tự chấm lại với <Link to="/cong-cu/pitch-deck-10-slide">checklist 10 slide</Link>.</p></section>
                    : <FormGui key={luotCu?.id || "moi"} user={user} luotCu={luotCu} conLai={hm.conLai} onDaGui={(id) => setParams({ xem: id })} />}
              </>
            )}
        </div>

        <aside className="nx-ben" aria-label="Về dịch vụ nhận xét">
          <section className="cct nx-the" style={{ "--mau": "#86cfaa" }}>
            <h2 className="cct-ten">Bạn nhận được gì</h2>
            <ul>
              <li>Điểm tổng và mức sẵn sàng gửi quỹ.</li>
              <li>Tối đa 5 việc nên sửa trước, xếp theo mức ảnh hưởng tới quyết định của nhà đầu tư.</li>
              <li>Nhận xét từng slide, kèm câu chữ gợi ý để viết lại.</li>
              <li>Những câu hỏi nhà đầu tư gần như chắc chắn sẽ hỏi.</li>
            </ul>
          </section>
          <section className="cct nx-the" style={{ "--mau": "#9fb7e0" }}>
            <h2 className="cct-ten">Cách chúng tôi nhận xét</h2>
            <p>AI đọc deck đối chiếu với toàn bộ hướng dẫn trên website: <Link to="/cong-cu/pitch-deck-10-slide">checklist 10 slide</Link>, các bài <Link to="/playbook">Playbook</Link> và góc nhìn của quỹ. Số liệu trong deck được trích ra và kiểm tra chéo bằng công thức (cộng dồn, tỷ lệ, khớp giữa các slide) trước khi chấm. Đây là nhận xét tự động: dùng để sửa nhanh trước khi gửi quỹ, không thay cho góp ý của mentor hay nhà đầu tư.</p>
          </section>
          <section className="cct nx-the" style={{ "--mau": "#c3b1e6" }}>
            <h2 className="cct-ten">Deck của bạn được giữ kín</h2>
            <ul>
              <li>Chỉ bạn xem được nhận xét. Quản trị fundraising.vn chỉ mở deck khi cần xử lý lỗi.</li>
              <li>Không chia sẻ cho quỹ hay bất kỳ ai khác.</li>
              <li>Tệp deck tự xoá sau {NGAY_GIU_DECK} ngày kể từ khi gửi nhận xét. Bạn tự xoá được bất cứ lúc nào.</li>
            </ul>
            <span className="cct-chan"><span>Miễn phí, mỗi tài khoản tối đa {GIOI_HAN_TUAN} lần nhận xét trong {SO_NGAY_HAN_MUC} ngày.</span></span>
          </section>
        </aside>
      </div>

      <section className="nx-hoi-dap">
        <h2>Câu hỏi thường gặp</h2>
        <div className="nx-hoi-dap-luoi">
        <details className="surface"><summary>Deck bằng tiếng Anh có được không?</summary><p>Được. Nhận xét viết bằng tiếng Việt; phần gợi ý viết lại giữ ngôn ngữ của deck khi cần.</p></details>
        <details className="surface"><summary>Có sửa thẳng vào file deck giúp không?</summary><p>Không. Bạn nhận nhận xét từng slide kèm câu chữ gợi ý; bạn tự sửa trên file của mình để giữ đúng giọng và số liệu của công ty.</p></details>
        <details className="surface"><summary>Có giới thiệu deck của tôi cho quỹ không?</summary><p>Không. Deck chỉ dùng để nhận xét. Muốn tìm quỹ phù hợp, dùng công cụ <Link to="/cong-cu/quy-phu-hop">đối chiếu nguồn vốn</Link>.</p></details>
        <details className="surface"><summary>Chưa có deck thì bắt đầu từ đâu?</summary><p>Đọc <Link to="/playbook/pitch-deck-tot-va-chua-tot">Pitch deck tốt và chưa tốt</Link>, rồi dùng <Link to="/cong-cu/pitch-deck-10-slide">checklist 10 slide</Link> để dựng khung trước.</p></details>
        </div>
      </section>
    </div>
  );
}
